<template>
  <aside class="sidebar" :class="{ 'is-open': isOpen }">
    <div class="sidebar-header">
      <h3>Menu</h3>
      <button @click="closeSidebar" class="close-btn" title="Close Menu">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="sidebar-content">
      <button
        @click="navigateTo('contabilidad')"
        class="sidebar-btn"
        :class="{ active: activeTab === 'contabilidad' }"
        title="Contabilidad"
      >
        <span class="material-icons">assignment</span>
        <span class="btn-text">Contabilidad</span>
      </button>
      <button
        @click="navigateTo('mapa')"
        class="sidebar-btn"
        :class="{ active: activeTab === 'mapa' }"
        title="Mapa"
      >
        <span class="material-icons">map</span>
        <span class="btn-text">Mapa</span>
      </button>
      <button
        @click="navigateTo('actividades')"
        class="sidebar-btn"
        :class="{ active: activeTab === 'actividades' }"
        title="Registro de Actividades"
      >
        <span class="material-icons">history</span>
        <span class="btn-text">Registro de Actividades</span>
      </button>
      <button
        @click="navigateTo('notas')"
        class="sidebar-btn"
        :class="{ active: activeTab === 'notas' }"
        title="Notas"
      >
        <span class="material-icons">note</span>
        <span class="btn-text">Notas</span>
      </button>
      <div class="sidebar-separator"></div>
      <button @click="openSettings" class="sidebar-btn" title="Settings">
        <span class="material-icons">settings</span>
        <span class="btn-text">Ajustes</span>
      </button>
    </div>
    <div class="sidebar-footer">
      <span class="version-text">v{{ version }}</span>
    </div>
  </aside>
</template>

<script>
import pkg from '../../package.json'

export default {
  name: 'SidebarNav',
  data() {
    return { version: pkg.version }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: 'contabilidad',
    },
  },
  emits: ['open-settings', 'close', 'navigate'],
  methods: {
    navigateTo(tab) {
      this.$emit('navigate', tab)
    },
    openSettings() {
      this.$emit('open-settings')
    },
    closeSidebar() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.sidebar {
  width: 280px; /* Wider sidebar */
  background-color: #2f3136;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 1002;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
}

/* Add top padding for PWA standalone mode */
@media (display-mode: standalone) {
  .sidebar {
    padding-top: env(safe-area-inset-top, 44px);
    height: calc(100% - env(safe-area-inset-top, 44px));
  }
}

/* iOS specific adjustments */
@supports (-webkit-appearance: none) {
  @media (display-mode: standalone) {
    .sidebar {
      padding-top: max(env(safe-area-inset-top), 44px);
      height: calc(100% - max(env(safe-area-inset-top), 44px));
    }
  }
}

.sidebar.is-open {
  transform: translateX(0);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #4f545c;
  flex-shrink: 0;
}

.sidebar-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 20px;
}

.close-btn {
  background: none;
  border: none;
  color: #b9bbbe;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #4f545c;
}

.sidebar-content {
  padding: 16px;
}

.sidebar-btn {
  background: none;
  border: none;
  color: #b9bbbe;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  transition: background-color 0.2s;
  font-size: 16px;
}

.sidebar-btn:hover {
  background-color: #4f545c;
}

.sidebar-separator {
  height: 1px;
  background-color: #4f545c;
  margin: 16px 0;
}

.btn-text {
  font-weight: 500;
}

.sidebar-btn .material-icons {
  font-size: 28px;
}

.sidebar-footer {
  margin-top: auto;
  padding: 16px;
  border-top: 1px solid #4f545c;
}

.version-text {
  color: #72767d;
  font-size: 12px;
}
</style>
